import React from 'react';
import Section, { SectionTitle } from './Section';

const FAQItem = ({ question, answer }) => (
  <div className="bg-white p-6 rounded-lg shadow-md">
    <h3 className="text-xl font-bold text-secondary mb-2">{question}</h3>
    <p className="text-gray-700">{answer}</p>
  </div>
);

const FAQSection = ({ title = "Frequently Asked Questions", faqs = [], background = "light" }) => {
  return (
    <Section background={background}>
      <SectionTitle>{title}</SectionTitle>
      <div className="max-w-4xl mx-auto space-y-6">
        {faqs.map((faq, index) => (
          <FAQItem key={index} question={faq.question} answer={faq.answer} />
        ))}
      </div>
    </Section>
  );
};

export default FAQSection;
export { FAQItem };